module.exports = __webpack_public_path__ + "img/26.c31d59e1.jpg";